import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { loginFormSchema, LoginFormData } from "./validation";

export const useLoginForm = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const form = useForm<LoginFormData>({
    resolver: zodResolver(loginFormSchema),
    defaultValues: {
      username: "",
      password: ""
    },
  });

  const onSubmit = async (values: LoginFormData) => {
    setIsSubmitting(true);
    
    try {
      console.log("Attempting login with username:", values.username);
      
      const success = await login(values.username, values.password);
      
      if (success) {
        console.log("Login successful, redirecting to dashboard");
        navigate("/dashboard");
      } else {
        console.log("Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Er is een fout opgetreden bij het inloggen");
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    form,
    isSubmitting,
    onSubmit: form.handleSubmit(onSubmit)
  };
};